import React from 'react';
import { ChevronUpIcon, ChevronDownIcon } from '@rsos/assets/icons';
import { IconWrapper } from '../styles/Users.styles';

/**
 * @param {String} value - one of the following headers [NAME, EMAIL, ROLE, LAST_ACTIVE]
 * @param {String} sortedByValue - which header value to sort by
 * @param {Boolean} shouldReverse - determine direction of chevron icon
 */

export const SortIconWrapper = ({ value, sortedByValue, shouldReverse }) => {
  return sortedByValue && sortedByValue === value ? (
    <IconWrapper>
      {shouldReverse ? (
        <ChevronDownIcon width={12} height={12} />
      ) : (
        <ChevronUpIcon width={12} height={12} />
      )}
    </IconWrapper>
  ) : null;
};
